import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SearchPage from "./pages/Search";
import CandidateProfile from "./pages/CandidateProfile";
import Sync from "./pages/Sync";
import UserManagement from "./pages/UserManagement";
import SyncLog from "./pages/SyncLog";
import Settings from "./pages/Settings";
import GoogleCallback from "./pages/GoogleCallback";
import TeamProductivity from "./pages/TeamProductivity";
import RecruiterProductivity from "./pages/RecruiterProductivity";
import FollowUps from "./pages/FollowUps";
import ResetPassword from "./pages/ResetPassword";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/search" element={<Protected><SearchPage /></Protected>} />
          <Route path="/candidate/:id" element={<Protected><CandidateProfile /></Protected>} />
          <Route path="/sync" element={<Protected><Sync /></Protected>} />
          <Route path="/productivity" element={<Protected roles={["super_custodian", "hod", "tl"]}><TeamProductivity /></Protected>} />
          <Route path="/productivity/recruiter/:email" element={<Protected><RecruiterProductivity /></Protected>} />
          <Route path="/users" element={<Protected roles={["super_custodian", "hod"]}><UserManagement /></Protected>} />
          <Route path="/sync-log" element={<Protected><SyncLog /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/follow-ups" element={<Protected><FollowUps /></Protected>} />
          <Route path="/reset-password" element={<Protected><ResetPassword /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
